<template>
  <div class="icon-placeholder">
    <slot></slot>
  </div>
</template>

<style src="~/assets/styles/components/icon-placeholder/icon-placeholder.scss" lang="scss" />
